export default {
  props: ['id'],
  data() {
    return {
      qty: 1,
      dialog: false,
      width: window.innerWidth,
      size: '',
      rules: {
        required: v => !!v || 'Поле должно быть заполнено',
      },
    };
  },
  computed: {
    user() { return this.$store.state.user; },
    product() { return this.$store.state.shop.product; },
    limits() { return this.$store.state.shop.product.limits; },
    carouselHeight() {
      let height = 300;

      if (this.width < 960) {
        height = this.width - 36;
      }

      if (this.width >= 960 && this.width < 1340) {
        height = (this.width - 50) / 1.5;
      }

      if (this.width >= 1340) {
        height = 840;
      }

      return height;
    },
    checkLimits() {
      return (this.limits[this.size] && this.limits[this.size] >= this.qty) ? true : 'Нет выбранного количества';
    },
  },
  methods: {
    async AddToCart(item) {
      const payload = item;
      payload.qty = this.qty;
      payload.size = this.size;
      const app = this;
      app.$store.getters.axl.post('/shop/api-v3/product/check-limits', payload)
        .then((response) => {
          if (response.data.status === 'ok') {
            this.$store.dispatch('shop/AddToCart', payload);
            this.dialog = true;
          } else {
            this.$store.dispatch('ShowError', 'В наличии нет такого количества товара');
          }
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
        });
    },
    ChangeQty(e) {
      this.qty = +e.target.value ? +e.target.value : 1;
    },
    ChangeSize(e) {
      this.size = e.target.value && this.product.sizes && this.product.sizes.length
        ? e.target.value
        : this.product.sizes[0];
    },
    HandleResize() {
      this.width = window.innerWidth;
    },
  },
  async mounted() {
    window.addEventListener('resize', this.HandleResize);
    await this.$store.dispatch('shop/GetProduct', { product_id: this.$props.id });
    if (this.product && this.product.sizes && this.product.sizes.length) {
      // eslint-disable-next-line
      this.size = this.product.sizes[0];
    }
    if (this.product && this.product.limits && this.product.sizes.limits) {
      this.limits = this.product.limits;
    }
  },
  destroyed() {
    window.removeEventListener('resize', this.HandleResize);
  },
};
